<template>
    <div class="products-page">
        <div class="page-tab-bar">
            <el-col :xs="1" :sm="1" :md="2" :lg="7" :xl="7">&nbsp;</el-col>
            <el-col class="tab-body" :xs="22" :sm="22" :md="20" :lg="10" :xl="10">
                <div class="tab-list">
                    <div class="tab-item" v-for="(item,index) in tabList" @click="changeTab" :data-index="index">
                        <img :src="item.image"/>
                        <div class="name" :class="[index == tabIndex?'active':'']">{{item.name}}</div>
                    </div>
                </div>
                <div class="line-content">
                    <li class="line" :style="line"></li>
                </div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="7" :xl="7">&nbsp;</el-col>
        </div>
        <div class="products-content" v-if="tabIndex != 3">
            <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="4">&nbsp;</el-col>
            <el-col class="content-body" :xs="22" :sm="22" :md="20" :lg="22" :xl="16">
                <div class="content-title">劲步{{tabList[tabIndex].name}}系列产品<span v-if="channelWidth <= 768">({{list.length}})</span></div>
                <div class="products-list">
                    <div class="products-item" v-for="(item,index) in list" v-if="tabIndex!=1 || index<list.length-1">
                        <img :src="item.image" :title="item.info" @click="routerTo" data-params="more" :data-index="index" style="cursor: pointer"/>
                        <div class="item-info">
                            <div class="item-name">{{item.name}}</div>
                            <div class="item-info">{{item.info}}</div>
                            <div class="item-btn">
                                <div class="view-btn" @click="routerTo" data-params="buy" :data-index="index">询价购买</div>
                                <div class="show-more" @click="routerTo" data-params="more" :data-index="index">
                                    <div>了解详情</div>
                                    <img :src="arrowBlueIcon"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="list-other" v-if="tabIndex == 1">
                        <div class="list-title">
                            <div class="line"></div>
                            <div style="margin: 0 20px;font-style:24px;font-weight: bold">配件</div>
                            <div class="line"></div>
                        </div>
                        <div class="products-item">
                            <img :src="list[list.length-1].image" :title="list[list.length-1].info" @click="routerTo" data-params="buy" :data-index="list.length-1" style="cursor: pointer"/>
                            <div class="item-info">
                                <div class="item-name">{{list[list.length-1].name}}</div>
                                <div class="item-info">{{list[list.length-1].info}}</div>
                                <div class="item-btn">
                                    <div class="view-btn" @click="routerTo" data-params="buy" data-index="8">询价购买</div>
                                    <div class="show-more" @click="routerTo" data-params="more" data-index="8">
                                        <div>了解详情</div>
                                        <img :src="arrowBlueIcon"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="4">&nbsp;</el-col>
        </div>
        <div class="platform" v-else>
            <img class="header-image" :src="functionHeaderImage" v-if="channelWidth>768" style="width: 100%;height: auto"/>
            <img class="header-image" :src="phoneFunctionHeaderImage" v-else style="width: 100%;height: auto"/>
            <div class="products-content function-block">
                <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
                <el-col class="content-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                    <div class="title">
                        功能特点
                    </div>
                    <img class="title-bg" :src="ioyIcon" style="left: 51%" v-if="channelWidth>768"/>
                    <function-point-block v-for="item in functionList" :info="item"></function-point-block>
                </el-col>
                <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            </div>
            <div class="products-content function-block" style="background: #F1F2F7;">
                <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
                <el-col class="content-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                    <div class="title">
                        云平台结构
                    </div>
                    <img class="title-bg" :src="ioyIcon" style="left: 51.5%" v-if="channelWidth>768"/>
                    <div class="structure-content">
                        <img :src="structureImage"/>
                        <div class="structure-info-block">
                            <structure-block v-for="item in structureList" :info="item"></structure-block>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            </div>
            <div class="products-content function-block" style="background: #FFFAE5;">
                <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
                <el-col class="content-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16" style="padding: 30px 0">
                    <div class="to-buy">
                        <div>如果使用时有疑惑的或者您有什么想法建议，请联系我们</div>
                        <div class="view-btn" @click="routerTo" data-params="buy" data-index="0">立即咨询</div>
                    </div>
                </el-col>
                <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            </div>

        </div>
    </div>
</template>

<script>
    //图片引入
    import ProductsTabIcon1 from '../../image/common/products_tab_icon1.png'
    import ProductsTabIcon2 from '../../image/common/products_tab_icon2.png'
    import ProductsTabIcon3 from '../../image/common/products_tab_icon3.png'
    import ProductsTabIcon4 from '../../image/common/products_tab_icon4.png'
    import ProductsImg from '../../image/common/products_img.png'
    import gatewayImage1 from '../../image/products/IWG_M20_Mini.png'
    import gatewayImage2 from '../../image/products/IWG_200.png'
    import gatewayImage3 from '../../image/products/Industry.png'
    import ArrowBlueIcon from '../../image/arrow_blue.png'
    import PointImage1 from '../../image/common/point_img1.png'
    import PointImage2 from '../../image/common/point_img2.png'
    import PointImage3 from '../../image/common/point_img3.png'
    import PointImage4 from '../../image/common/point_img4.png'
    import PointImage5 from '../../image/common/point_img5.png'
    import PointIcon1 from '../../image/common/point_icon1.png'
    import PointIcon2 from '../../image/common/point_icon2.png'
    import PointIcon3 from '../../image/common/point_icon3.png'
    import PointIcon4 from '../../image/common/point_icon4.png'
    import PointIcon5 from '../../image/common/point_icon5.png'
    import FunctionHeaderImage from '../../image/common/function_header_image.png'
    import PhoneFunctionHeaderImage from '../../image/common/phone_function_header_image.png'
    import IoyIcon from '../../image/common/iot_icon.png'
    import StructureIcon1 from '../../image/common/structure_icon1.png'
    import StructureIcon2 from '../../image/common/structure_icon2.png'
    import StructureIcon3 from '../../image/common/structure_icon3.png'
    import StructureIcon4 from '../../image/common/structure_icon4.png'
    import StructureImage from '../../image/common/structure_image.png'
    import sensor1 from '../../image/products/sensor1.png'
    import sensor2 from '../../image/products/sensor2.png'
    import sensor3 from '../../image/products/sensor3.png'
    import sensor4 from '../../image/products/sensor4.png'
    import sensor5 from '../../image/products/sensor5.png'
    import sensor6 from '../../image/products/sensor6.png'
    import sensor7 from '../../image/products/sensor7.png'
    import sensor8 from '../../image/products/sensor8.png'
    import sensor9 from '../../image/products/sensor9.png'

    import ProductsImage1 from '../../image/common/products_image1.png'
    import ProductsImage2 from '../../image/common/products_image2.png'
    import JinBuImg1 from '../../image/products/jinBu_img1.png'
    import JinBuImg2 from '../../image/products/jinBu_img2.png'
    import IWGImg from '../../image/products/IWG200_img.png'
    import GatWay3Img1 from '../../image/products/gateway3_img1.png'
    import GatWay3Img2 from '../../image/products/gateway3_img2.png'
    import OnlineImg1 from '../../image/products/online_img1.png'
    import OnlineImg2 from '../../image/products/online_img2.png'
    import AirImg1 from '../../image/products/air_img1.png'
    import AirImg2 from '../../image/products/air_img2.png'
    import SpeedImg from '../../image/products/speed_img.png'
    import DirectionImg from '../../image/products/direction_img.png'
    import HumanImg from '../../image/products/human_img.png'
    import THImg from '../../image/products/TH_img.png'
    import WaterImg from '../../image/products/water_img.png'
    import SmokeImg1 from '../../image/products/smoke_img1.png'
    import SmokeImg2 from '../../image/products/smoke_img2.png'
    import BoxImg1 from '../../image/products/box_img1.png'
    import BoxImg2 from '../../image/products/box_img2.png'
    import Camera1 from '../../image/products/camera1.png'
    import Camera2 from '../../image/products/camera2.png'
    import Camera1Img from '../../image/products/camera1_image.png'
    import Camera2Img from '../../image/products/camera2_image.png'
    import IWGNormsImg from '../../image/products/IWG_norms_img.png'
    import NormsImage1 from '../../image/common/norms1.png'
    import OutNormsImg from '../../image/products/out_norms_img.png'
    import GatWay3NormsImg from '../../image/products/gat_way3_norms_img.png'
    import OnlineNormsImg from '../../image/products/online_norms_img.png'
    import AirNormsImg from '../../image/products/air_norms_img.png'
    import SpeedNormsImg from '../../image/products/speed_norms_img.png'
    import DirectionNormsImg from '../../image/products/direction_norms_img.png'
    import HumanNormsImg from '../../image/products/human_norms_img.png'
    import THNormsImg from '../../image/products/TH_norms_img.png'
    import WaterNormsImg from '../../image/products/water_norms_img.png'
    import SmokeNormsImg from '../../image/products/smoke_norms_img.png'
    import SmartAppearanceImg from '../../image/products/camera/smart_appearance.png'
    import SmartNormsImg from '../../image/products/camera/smart_norms.png'
    import SmartInfoImg from '../../image/products/camera/smart_info.png'
    import SmartAppearanceImg2 from '../../image/products/camera/smart_appearance2.png'
    import SmartNormsImg2 from '../../image/products/camera/smart_norms2.png'
    import SmartInfoImg2 from '../../image/products/camera/smart_info2.png'
    import SmartAppearanceImg3 from '../../image/products/camera/smart_appearance3.png'
    import SmartNormsImg3 from '../../image/products/camera/smart_norms3.png'
    import SmartInfoImg3 from '../../image/products/camera/smart_info3.png'
    import SmartInfo3a from '../../image/products/camera/smart_info3.1.png'
    import SmartAppearanceImg4 from '../../image/products/camera/smart_appearance4.png'
    import SmartNormsImg4 from '../../image/products/camera/smart_norms4.png'
    import SmartInfoImg4 from '../../image/products/camera/smart_info4.png'
    import SmartInfoImg4a from '../../image/products/camera/smart_info4a.png'
    import ZKGW5000AImg from '../../image/products/ZKGW5000A.png'
    import zNormsImg1 from '../../image/products/z_norms1.png'
    import zNormsImg2 from '../../image/products/z_norms2.png'
    import ZKGW1000Img from '../../image/products/ZKGW1000.png'
    import z1000Img from '../../image/products/z_1000_norms.png'
    import ZKImg from '../../image/products/ZK_img.png'
    import ZKImage from '../../image/products/ZK_image.png'
    import ANImg from '../../image/products/AN-122_img.png'
    import ANNorms from '../../image/products/AN_norms.png'
    import an205Img from '../../image/products/205_img.png'
    import an205NormsImg from '../../image/products/205_norms_img.png'
    import an206Img from '../../image/products/206_img.png'
    import an206NormsImg from '../../image/products/206_norms_img.png'


    //组件引入
    import FunctionPointBlock from '../../../components/function-point-block/function-point-block'
    import StructureBlock from '../../../components/structure-block/structure-block'

    export default {
        name: "products-page",
        components:{
            FunctionPointBlock,
            StructureBlock
        },
        data(){
            return{
                arrowBlueIcon:ArrowBlueIcon,
                functionHeaderImage:FunctionHeaderImage,
                phoneFunctionHeaderImage:PhoneFunctionHeaderImage,
                structureImage:StructureImage,
                ioyIcon:IoyIcon,
                channelWidth:null,
                tabList:[
                    {name:'网关',image:ProductsTabIcon1,
                        list:[              //产品列表
                            {name:'劲步网关',norms:[],appearance:[JinBuImg1,JinBuImg2],image:ProductsImg,info:'此网关内嵌完备可靠的协议栈，支持与各种协议的设备对接。',introduction:'',characteristic:'设备支持LoRa以及NB无线通信；支持北斗以及GPS系统定位功能；支持一路开关量输入以及一路开关量输出；支持一路CAN总线通信。'},
                            {name:'IWG M20 Mini 网关',norms:[NormsImage1,IWGNormsImg],appearance:[ProductsImage1,ProductsImage2],image:gatewayImage1,info:'可实现链路安全、数据加密通讯等功能。',introduction:'物联网网关的一种，工业级可运营、低成本可补盲LoRa网关，接入各类应用节点，可实现链路安全、数据加密通讯、压缩等功能。',characteristic:'支持3G/4G及 有线FE数据回传，支持GPS/北斗定位并提供授时功能，支持220V市电、12~24V 直流供电。'},
                            {name:'IWG 200室外型网关',norms:[OutNormsImg],appearance:[IWGImg],image:gatewayImage2,info:'可实现链路安全、数据加密通讯等功能。',introduction:'IWG200专为快速部署低功耗广域网（LPWAN）而设计，具备易用耐用、性能可靠稳定、扩展性好、性能指标优异的特点。',characteristic:'支持3G/4G及有线FE数据回传，支持 WiFi就近无线配置管理，支持GPS/北斗定位并提供授时功能，支持市电、POE、太阳能多方式供电。'},
                            {name:'异构聚合工业网关',norms:[GatWay3NormsImg],appearance:[GatWay3Img1,GatWay3Img2],image:gatewayImage3,info:'适用于TF 卡、LED 状态指示灯、蜂鸣器等。',introduction:'设备具有易用耐用、性能可靠稳定、性能指标优异等特点；支持北斗及GPS系统定位功能；支持LoRa以及NB等无线通信；支持与各种协议的设备对接。',characteristic:'基于 Semtech 的新一代 LoRa 网关芯片组 SX1302 和 SX1250 设计开发的一款透传 LoRa 网关模组，采用 Mini PCI-e 硬件接口，3.3V 供电，支持 UART 和 USB，支持 8 个独立接收信道和 1 个发射信道，全双工设计。 '},
                            {name:'ZKGW5000A工业级网关',norms:[zNormsImg1,zNormsImg2],appearance:[ZKGW5000AImg],image:ZKGW5000AImg,info:'采用Semtech SX1301芯片方案、8信道LoRaWAN通信、全球频段',introduction:'',characteristic:'ZKGW5000A工业级网关主要为运营商和企业用户提供大范围的LoRa接入服务。合金外壳、IP67防护，支持远程配置、升级;可实现城市1~3km，郊区10~15km覆盖半径。'},
                            {name:'ZKGW1000室内网关',norms:[z1000Img],appearance:[ZKGW1000Img],image:ZKGW1000Img,info:'ZKGW1000室内网关可单独使用，充分发挥小范围覆盖、经济实用的特点',introduction:'ZKGW1000室内网关可单独使用，充分发挥小范围覆盖、经济实用的特点，应用于智慧消防、智能家居、智能楼宇、室内停车、智慧仓储、智能抄表等室内场合；也可与室外网关联合使用，补充室外网关的LoRa网络信号盲区，实现更大范围、更优信号的网络覆盖，应用于智慧社区、产业园区等场景。',characteristic:'支持Wi-Fi、LTE全网通和以太网接入通信能力等多种联网接入方式\n'},

                        ]},
                    {name:'传感器',image:ProductsTabIcon2,
                        list:[              //产品列表
                            {name:'粮情在线检测分机',norms:[OnlineNormsImg],appearance:[OnlineImg1,OnlineImg2],image:sensor1,info:'分机可连接若干分支器，温、湿度传感器等设备。',introduction:'分机可连接若干分支器，温、湿度传感器等设备。它接收主机指令，逐点采集粮堆各点温度并把这些数据上传给检测主机。该分机设计时采用低功耗设计，能长时间加工电工作，同时设计时还采取了防雷措施，断电时物理隔离，通电时防雷保护，可起到防静电、防电磁场、防雷击的作用。',characteristic:'采集温、湿度数据；特制优质不锈钢密封外壳，表面静电喷塑处理；内置式隔离电源（光电隔离，可防雷击）；容量：256X4个测温点，8个测湿点；抗电磁干扰、抗雷击性能可靠，安装、维护方便；使用寿命不低于10年；'},
                            {name:'大气压力温湿度传感器',norms:[AirNormsImg],appearance:[AirImg1,AirImg2],image:sensor2,info:'可测试大气压力、温度、湿度等，具有体积小、防紫外线等优点。',introduction:'可测试大气压力、温度、湿度等，具有体积小、防雨雪、防紫外线等优点，广泛用于室外、通讯机房、智能楼宇、地铁、商场、图书馆等场所，特别适用于对温度要求精准测量、精准控制的领域。',characteristic:'精度、长期稳定性、一致性优秀，出口畅销国外；搭配有人RTU可提供云组态平台，可根据现场情况自行配置组态界面，手机随时查看数据及报警；抗结露能力强，适于高湿环境下长期工作； IP65防水防尘。'},
                            {name:'风速传感器 ',norms:[SpeedNormsImg],appearance:[SpeedImg],image:sensor3,info:'三杯式外观设计，360度风速测量，功耗低；测量精度高，稳定性好。',introduction:'三杯式外观设计，风杯选用碳纤维材料，强度高，启动好；360度风速测量，功耗低，较强的抗干扰能力，能长期稳定工作，内置大容量FLASH存储芯片可自动存储至少一年的气象数据。',characteristic:'继电器报警控制输出，可对报警点进行参数设置，蜂鸣器声音提示报警；迷你型显示器，四位数码管显示，16向风向显示，可任意切换风速与风级显示；电源适应范围宽，数据信息线性度好，信号传输距离长；测量精度高，量程范围宽，稳定性好。'},
                            {name:'风向传感器 ',norms:[DirectionNormsImg],appearance:[DirectionImg],image:sensor4,info:'铝壳包裹，具有测量精准，响应灵敏，防水防腐，抗干扰强等优点。',introduction:'风向传感器采用低惯性风标及精密电位器，灵敏度高，精度高；仪器配备有RS232或RS485接口用于与计算机建立有线通讯连接，还可选配GPRS无线模块建立远程无线连接，通过配套的上位机软件可远程观测实时风向，用户还可利用该功能完善的气象软件对气象数据作进一步的处理分析。',characteristic:'铝壳包裹，具有测量精准，响应灵敏，防水防腐，抗干扰强等优点；兼容4~20ma电流输出型传感器，可灵活设置风速测量范围；带RS232/485通讯输出，可接入PC，由上位机软件供显示，存储，分析；带4~20ma电流环输出，可接入PLC系统。'},
                            {name:'人体红外传感器',norms:[HumanNormsImg],appearance:[HumanImg],image:sensor5,info:'采用先进的信号分析处理技术，适用于厂房、仓库、写字楼等场所。',introduction:'本产品可自动探测区域内人体的活动，当有入侵者通过监控区域并有动态移动现象时，会即时向监控平台发送报警信号，适合家庭住宅区、别墅、厂房、商场、仓库、写字楼等场所的安全防范。',characteristic:'1、支持LoRaWAN无线远程实时报警；2、支持壁挂或吸顶安装，探测距离8-10米；3、内置电池供电， 电池寿命5年以上；4、支持防拆报警、低电压检测、状态报告等功能。'},
                            {name:'温湿度传感器',norms:[THNormsImg],appearance:[THImg],image:sensor6,info:'产品内置温湿度传感器芯片，具有检测精度高、性能稳定等特点。',introduction:'此产品是集数据采集、监测于一体的无线温湿度采集单元。广泛适用于通信机房、车间生产线、药品仓库、大型物流仓库、农业大棚、温室花卉大棚、档案馆、博物馆、暖通控制等需要温湿度监测报警的物联网场景。',characteristic:'产品内置温湿度传感器芯片，具有检测精度高、性能稳定、体积小、功耗低、信号传输距离远等特点。所支持的工作频率有CN470\\EU868MHz\\AU915 MHz \\US915 MHz\\AS923MHz，温度检测范围：-40℃～80℃，精度：±0.3℃；湿度检测范围：0～99.9%RH, 精度：±2%RH；电池供电，电池寿命长达3年，可自主设定温湿度上下限报警值'},
                            {name:'水浸传感器',norms:[WaterNormsImg],appearance:[WaterImg],image:sensor7,info:'采用防水外壳，防护等级高，性能稳定可长时间工作，灵敏度高触水即报。',introduction:'产品由数据采集盒与水浸传感器两部分组成，水浸传感器利用液体导电原理，采用4探针检测漏水情况，正常时两极探头被空气绝缘，在浸水状态下探头导通产生告警信号，高灵敏度精准检测漏水事件。',characteristic:'设备采用低功耗一体化设计，工作寿命及服务周期长达十年以上，电池更换频率大幅降低；壳体采用尼龙加玻纤材质设计，坚固、耐用，支持IP67防护等级，可在恶劣环境条件下使用；自定义报警输出常开/常闭自动报警。'},
                            {name:'烟感报警器',norms:[SmokeNormsImg],appearance:[SmokeImg1,SmokeImg2],image:sensor8,info:'采用智能优质芯片制作，提高待机时长，双向传感提高精准度，可多人连接接收警报。',introduction:'采用CPU控制，能够智能判断火灾时产生的烟雾并报警。报警器内置高音量蜂鸣器，报警后发出高分贝的声响，让周围的人们预知火情。广范应用于住宅、学校、休闲厅、咖啡厅、歌舞厅、社区、工厂、宾馆、养老院、福利院、古建筑等场所。',characteristic:'采用光电烟雾传感器检测；报警方式采用指示灯、 声音、无线远程报警；独特的三色指示灯指示报警器的各种状态；报警音量大于80dB (正前方3m处)；内置9V锂电池供电， 持续工作时间可长达3年；支持低电压、故障数据上报；吸顶式安装'},
                            {name:'ZK-LoRaBox数据主机',norms:[ZKImage],appearance:[ZKImg],image:ZKImg,info:'ZK-LoRaBox数据主机主要用于各种传感器的数据采集。',introduction:'提供了丰富外围接口，与外部模拟量及数字传感器连接，并向这些传感器供电。',characteristic:'设备支持NB-IoT/LoRaWAN两种数据回传方式；支持RS232/RS485等接口和外部传感器连接；采用低功耗设计，也可选择电池供电；'},
                            {name:'AN-122 LoRa+GPS 定位器',norms:[ANNorms],appearance:[ANImg],image:ANImg,info:'基于标准LoRaWAN™协议',introduction:'支持GPS/北斗定位，定位精度5米以内',characteristic:'内置3.6V/8000mAh或3.7V/2000mAh可充电锂电池供电;用于政企事业单位的动产监管以及畜牧、交通等领域\n'},
                            {name:'AN-205 无线土壤温湿度监测单元',norms:[an205NormsImg],appearance:[an205Img],image:an205Img,info:'采用专业的土壤水分温度传感器探头，高精度',introduction:'可长期埋入土壤，耐腐蚀，完全防水;NB-IoT/LoRaWAN数据回传方式可选\n',characteristic:'供电方式 DC 12V-24V（可自选太阳能供电）;IP65的防护等级，可在室内外恶劣环境下使用\n'},
                            {name:'AN-206无线水质pH值监测单元',norms:[an206NormsImg],appearance:[an206Img],image:an206Img,info:'NB-IoT/LoRaWAN数据回传方式可选\n',introduction:'探头采用pH玻璃电极和银氯化银参比电极复合而成\n',characteristic:'传感器测量范围宽0~14pH，精度±0.01pH线性度好;供电方式 DC 12V-24V（可自选太阳能供电）;用于火电、化工化肥、冶金、环保、制药、生化等\n'},
                            {name:'工程专用箱',norms:[],appearance:[BoxImg1,BoxImg2],image:sensor9,info:'塑料材质绝缘防水，适用于多种设备，室内室外皆可进行安装。',introduction:'塑料材质绝缘防水，适用于多种设备，室内室外皆可进行安装。',characteristic:''},
                        ]},
                    {name:'摄像头',image:ProductsTabIcon3,
                        list:[              //产品列表
                            {name:'红外筒型网络摄像机',norms:[Camera1Img],appearance:[Camera1],image:Camera1,info:'支持走廊模式,透雾,并具有多种白平衡模式,适合各种场景需求',introduction:'',characteristic:'支持2560×1440@30fps实时帧率，图像更流畅；支持走廊模式,透雾,并具有多种白平衡模式,适合各种场景需求;支持三级用户权限管理，支持授权的用户和密码，支持IP地址过滤;支持五码流技术，双路高清，支持同时20路取流'},
                            {name:'红外防水筒型摄像机',norms:[Camera2Img],appearance:[Camera2],image:Camera2,info:'支持ICR红外滤片式自动切换,自动彩转黑功能,实现昼夜监控',introduction:'',characteristic:'采用百万像素逐行扫描CMOS,捕捉运动图像无锯齿;支持同轴高清输出,图像清晰、细腻,分辨率达720p；支持ICR红外滤片式自动切换,自动彩转黑功能,实现昼夜监控\n'},
                            {name:'红外数字高清高速智能球机',norms:[SmartNormsImg],appearance:[SmartInfoImg],image:SmartAppearanceImg,info:'采用高效红外阵列，低功耗，照射距离达150m;支持智能运动跟踪功能;支持PAL/NTSC制式切换，具有良好的地区适用性',introduction:'',characteristic:'支持三维智能定位功能，配合DVR/客户端软件/IE可实现点击跟踪和放大；支持3D数字降噪；红外灯与倍率距离匹配算法，根据倍率及距离调节红外灯亮度和角度，使图像达到理想的状态;恒流电路设计，红外灯寿命达3万小时'},
                            {name:'星光级网络高清高速智能球机',norms:[SmartNormsImg2],appearance:[SmartInfoImg2],image:SmartAppearanceImg2,info:'支持手动跟踪、全景跟踪、事件跟踪等多种跟踪方式并支持多场景巡航跟踪功能;支持人脸侦测、区域入侵侦测、越界侦测等智能侦测功能',introduction:'',characteristic:'采用高性能传感器，图像清晰，最大分辨率可达1920x1080;水平方向360°连续旋转，垂直方向-15°-90°,无监视盲区；支持4条花样扫描,每条路径记录时间大于10分钟;支持自动光圈、自动聚焦、自动白平衡、背光补偿、宽动态'},
                            {name:'日夜型枪型数字摄像机',norms:[SmartNormsImg3],appearance:[SmartInfo3a,SmartInfoImg3],image:SmartAppearanceImg3,info:'逐行扫描CMOS,捕捉运动图像无锯齿;支持透雾,电子防抖,并具有多种白平衡模式,适合各种场景需求',introduction:'',characteristic:'具备越界侦测,场景变更侦测,区域入侵侦测,音频异常侦测,虚焦侦测,移动侦测,人脸侦测,动态分析等多种报警功能；码流平滑设置，适应客户不同场景下对图像质量、流畅性的不同要求;适用于金融、电信、政府、军警、学校、机场、工厂、酒店、博物馆、交通监控等需要高清无延时的场所。'},
                            {name:'日夜型枪型数字摄像机',norms:[SmartNormsImg4],appearance:[SmartInfoImg4,SmartInfoImg4a],image:SmartAppearanceImg4,info:'支持3D数字降噪功能;最高分辨率可达2M (1920×1080)',introduction:'',characteristic:'采用逐行扫描CCD，捕捉运动图像无锯齿;采用先进的电路设计，具有高画质、低失真、低噪声等特性;适用于金融、电信、政府、学校、机场、工厂、酒店、博物馆、交通监控等要求超高清画质的场所'},

                        ]},
                    {name:'设备监控中心',image:ProductsTabIcon4}],
                tabIndex:0,
                line:{left:'0'},  //tab栏下划线
                list:[],
                functionList:[
                    {
                        title:'设备管理',
                        info:'可以将预授权的节点设备快速接入平台，在节点设备入网后，即可实时查看、管理节点的上报数据，并可通过控制面板对节点进行监测。',
                        image:PointImage1,
                        icon:PointIcon1,
                        isLeft:false,
                        pointList:['节点连接加密 ','设备健康监测','业务地图管理','告警消息推送','服务日志管理','用户组织管理','帐号权限设置','移动客户端']
                    },{
                        title:'网络管理',
                        info:'平台提供网络服务器供网关接入，可将预授权的网关注册到平台 ，建立网络连接，即可实时查看网关状态数据，在网关控制面板对网关进行',
                        image:PointImage2,
                        icon:PointIcon2,
                        isLeft:true,
                        pointList:['网关注册管理','网关参数配置','网关数据查看','网关状态监测','网关在线升级']
                    },{
                        title:'数据分析',
                        info:'平台可收集多种数据源数据，会对历史数据进行存储和管理，提 供消息队列进行实时数据服务，同时提供数据分析、数据可视化以及机器学',
                        image:PointImage3,
                        icon:PointIcon3,
                        isLeft:false,
                        pointList:['数据可视化','数据分析及展示','数据智能分析','数据汇集及挖掘','数据消息队列']
                    },{
                        title:'行为预警',
                        info:'平台会对设备的健康状态进行监测，并进行错误分析，在出现设 备问题时进行通知告警，并针对设备进行日志记录，以用于设备 状态分析。',
                        image:PointImage4,
                        icon:PointIcon4,
                        isLeft:true,
                        pointList:['设备健康监测','业务地图管理','告警消息推送','服务日志管理','用户组织管理']
                    },{
                        title:'手持端设备',
                        info:'为了满足不同的使用场景，开发了可在手持端设备上使用的版本 。移动端移植了后台的大部分功能，方便工作人员现场操作。',
                        image:PointImage5,
                        icon:PointIcon5,
                        isLeft:false,
                        pointList:['更多正在开发中...']
                    }
                ],
                structureList:[
                    {title:'网络设备',num:1,info:'传感器、摄像头、报警器等物联网设备连接到网关',image:StructureIcon1},
                    {title:'数据接入',num:2,info:'LoRa、TCP/ip、MQTT、HTTP/HTTPS、RTSTful、CoAP',image:StructureIcon2},
                    {title:'设备监控中心',num:3,info:'平台收集到数据后立刻进行数据分析，趋势预测等处理',image:StructureIcon3},
                    {title:'用户终端',num:4,info:'劲步设备监控中心后台、APP。供用户查询数据、控制设备。',image:StructureIcon4},
                ]
            }
        },
        created(){
            //拿取页面传参
          let index = this.$route.params.typeIndex;
          if(index){
              this.tabIndex = index;
              let left = `${25 * Number(index)}%`;
              this.line.left = left;
          }
          if(this.tabIndex!=3){
                this.list = this.tabList[this.tabIndex].list
            }
        },
        watch:{
            '$route'(newVal){
                if(this.$route.path === newVal.path){
                    this.$router.go(0)
                }
            },
            /**
             * 浏览器宽度变化赋值
             * @param newVal
             */
            '$store.state.screenWidth'(newVal){
                // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
                if (!this.timer) {
                    // 一旦监听到的productWidth值改变，就将其重新赋给data里的channelWidth.
                    this.channelWidth = newVal
                    this.timer = true;
                    setTimeout(() => {
                        // console.log(this.channelWidth);
                        this.timer = false;
                    }, 400);
                }
            }
        },
        mounted() {
            //获取浏览器宽度
            this.channelWidth = this.$store.state.screenWidth;

        },
        methods:{
            /**
             * 切换tab
             * @param e
             */
            changeTab(e){
                let index = e.currentTarget.dataset.index;
                this.tabIndex = index;
                //计算下划线移动
                let left = `${25 * Number(index)}%`;
                this.line.left = left;
                if(this.tabIndex!=3){
                    this.list = this.tabList[this.tabIndex].list
                }

            },
            /**
             * 页面跳转
             * @param e
             */
            routerTo(e){
                let pageName = e.currentTarget.dataset.params,
                    index = e.currentTarget.dataset.index,
                    list = this.list,
                    info = this.$utils.encodeURIAndStringify(list[index]);
                //缓存产品信息
                // if(sessionStorage.getItem('productsInfo') && !this.$utils.isEmpty(sessionStorage.getItem('productsInfo'))){
                //     sessionStorage.removeItem('productsInfo');
                // }
                // sessionStorage.setItem('productsInfo',info);

                this.$router.push({name:pageName,query:{value:info}});
                // console.log(pageName)
            }
        }
    }
</script>

<style lang="scss" src="./products-page.scss" scoped>

</style>
